<template>
    <div class="service--package" v-if="service.length !== 0">

        <b-row v-if="package_service.details.hotels.length == 0">
            <b-col cols="10" offset="1" class="d-flex align-items-center">
                <font-awesome-icon icon="plus" @click="add_hotel_to_overnight()"/>
                <small><i>Aggiungi un hotel</i></small>
            </b-col>
        </b-row>

        <div v-for="( hotel ) in package_service.details.hotels" v-bind:key="'hotel_'+hotel.hotel_index">
            <div class="package--wrapper">
                <b-row>
                    <b-col cols="10" offset="1">
                        <div class="service--package--hotels">
                            <hotel
                                :hotel="hotel"
                                :hotel_index="hotel.hotel_index"
                                :service_index="service.service_index"
                                v-on:removed="/*remove_hotel_from_service(hotel.hotel_index)*/"
                                v-on:updated="update_hotel_in_service"
                            />
                        </div>
                    </b-col>
                    <b-col cols="1" class="text-left">
                        <font-awesome-icon icon="times" @click="remove_hotel_from_service(hotel.hotel_index)"/>
                        <font-awesome-icon icon="plus" @click="add_hotel_to_overnight()"/>
                    </b-col>
                </b-row>
            </div>
        </div>        
        <!--
        <b-row>
            <b-col cols="12">
                <div class="service--package--hotels" v-for="( hotel ) in package_service.details.hotels" v-bind:key="'hotel_'+hotel.hotel_index">
                    <hotel
                        :hotel="hotel"
                        :hotel_index="hotel.hotel_index"
                        :service_index="service.service_index"
                        v-on:removed="remove_hotel_from_service(hotel.hotel_index)"
                        v-on:updated="update_hotel_in_service"
                    />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols-="12">
                <div class="service--item--add">
                    <b-badge @click="add_hotel_to_overnight()" variant="success">+ hotel</b-badge>
                </div>
            </b-col>
        </b-row>
        <b-badge show variant="danger">TODO: gestione campo "details" (possibile duplicato di public_data)</b-badge>-->
    </div>
</template>

<script>
import { new_overnight_hotel } from '@/quote'
import Hotel from '@/components/blocks/overnight/hotel'
export default {
    name: 'package',
    components: {
        'hotel': Hotel
    },
    props: {
        service: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {     
            package_service: this.service,
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_service()
        {
            this.$store.commit('set_service', {
                service: this.package_service
            })
        },
        add_hotel_to_overnight()
        {
            let index = 0
            this.package_service.details.hotels.forEach(hotel => {
                if(hotel.hotel_index >= index) index = hotel.hotel_index + 1
            })    
            this.package_service.details.hotels.push(new_overnight_hotel(index))
            this.update_service()
        },
        update_hotel_in_service(payload)
        {
            this.package_service.details.hotels[payload.hotel_index] = payload.hotel
            this.update_service()            
        },
        remove_hotel_from_service(hotel_index)
        {
            this.package_service.details.hotels = this.package_service.details.hotels.filter(function(hotel){
                return hotel.hotel_index !== hotel_index
            })
            this.update_service()
        }
    },
    computed: {
    }
}
</script>

<style lang="scss">
    .service--package
    {
        //margin-top:$grid-gutter-width/2;
        .service--icon
        {
            margin:0;
            height:100%;
            display:flex;
            align-items: center;
            justify-content: flex-start;
        }
        &--hotels
        {
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/2;
            }
        }
        .package--wrapper
        {
            .service--package--hotels
            {
                @include subpanel;
            }
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/2;
            }
        }
    }
</style>